module.exports = __webpack_public_path__ + "img/4.87c333b8.png";